import { App } from '@grafikr/components'

import './css/main.scss'
import 'vendor/lazysizes'

import components from 'framework/components'
import state from 'framework/state'


document.documentElement.style.setProperty(
  '--scrollbar-width',
  `${window.innerWidth - document.documentElement.clientWidth}px`
)
document.documentElement.style.setProperty('--viewport', `${window.innerHeight}px`)
window.addEventListener('resize', () => {
  document.documentElement.style.setProperty('--viewport', `${window.innerHeight}px`)
})

const app = new App()
components(app)
state(app)
app.mount()

document.addEventListener('shopify:section:load', ({ detail }) => {
  const section = document.getElementById(`shopify-section-${detail.sectionId}`)
  if (section) app.mount(section)
})
